import { RouteSummaryApp } from './RouteSummaryApp';
import { writable } from 'svelte/store';

export let rsa = writable<RouteSummaryApp>(new RouteSummaryApp());
